const breadcrumb = {
  state: {
    breadcrumbList: []
  },
  mutations: {
    // 层级进入
    SET_BREADCRUMB: (state, routeObj) => {
      let obj = {
        has: false,
        oindex: 0
      };
      state.breadcrumbList.filter((item, index) => {
        if (item.name == routeObj.meta.selfName) {
          obj = {
            has: true,
            oindex: index
          };
        }
      });
      if (obj.has) {
        state.breadcrumbList = state.breadcrumbList.slice(0, obj.oindex + 1);
      } else {
        state.breadcrumbList.push({
          name: routeObj.meta.selfName, // 标题名字
          path: routeObj.path, // 地址
          needQuery: routeObj.meta.needQuery || false, // 是否需要参数
          query: routeObj.query // 对应参数
        });
      }

      // state.breadcrumbList.push(item)
    },
    // 初始化
    SET_INIT: (state, item) => {
      state.breadcrumbList = item;
    }
  }
};

export default breadcrumb;
